import { render, staticRenderFns } from "./TrainingCertificateTile.vue?vue&type=template&id=31cac378&"
import script from "./TrainingCertificateTile.vue?vue&type=script&lang=js&"
export * from "./TrainingCertificateTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports